{
	"title": "Producten",
	"description": "Wat de shop verkoopt, met opties, varianten en prijzen.",
	"searchLabel": "Zoek op naam of SKU",
	"empty": "Er zijn nog geen producten.",
	"column": {
		"name": "Naam",
		"sku": "SKU",
		"price": "Prijs incl. btw",
		"status": "Status",
		"updated": "Gewijzigd"
	},
	"variantCount_one": "{{count}} variant",
	"variantCount_other": "{{count}} varianten",
	"priceRange": "{{min}} – {{max}}",
	"status": {
		"label": "Status",
		"active": "Actief",
		"inactive": "Inactief",
		"archived": "Gearchiveerd"
	},
	"new": {
		"title": "Nieuw product",
		"description": "Begin met naam en prijs. Opties en varianten voeg je daarna toe.",
		"submit": "Product aanmaken"
	},
	"field": {
		"name": "Naam",
		"slug": "Slug",
		"slugDescription": "Het adres in de shop: /product/{{slug}}. Kleine letters, cijfers en streepjes.",
		"description": "Omschrijving",
		"vatRate": "Btw-tarief",
		"vatOption": "{{rate}}%",
		"active": "Actief",
		"activeDescription": "Te koop in de shop.",
		"consumerPrice": "Prijs incl. btw",
		"sku": "SKU",
		"ean": "EAN",
		"eanDescription": "13 cijfers. Laat leeg als er geen barcode is.",
		"weight": "Gewicht (gram)",
		"seo": "Zoekmachines",
		"seoHelp": "Hoe het product in Google verschijnt. Leeg laten mag: dan gebruikt de shop de naam en het begin van de omschrijving.",
		"seoTitle": "SEO-titel",
		"seoDescription": "SEO-omschrijving",
		"length": "{{count}} van ongeveer {{advised}} tekens",
		"tooLong": "{{count}} tekens: langer dan {{advised}} wordt in Google meestal afgekapt",
		"lowStockThreshold": "Bijna op bij",
		"lowStockThresholdDescription": "Onder Voorraad staat een variant op \"Bijna op\" vanaf 1 tot en met dit aantal stuks. 0: nooit.",
		"piecesPerPack": "Aantal per verpakking",
		"piecesPerPackDescription": "Hoeveel doekjes of navullingen er in één verpakking zitten. De shop rekent er de prijs per stuk mee uit. Leeg laten voor iets zonder losse stuks, zoals een wisser.",
		"piecesPerPackBundleDescription": "Leeg laten: de shop telt de stuks van de onderdelen op. Vul alleen in als dat niet klopt.",
		"pieceNoun": "Naam van één stuk",
		"pieceNounDescription": "Enkelvoud, voor de prijs per stuk in de shop: \"€ 0,35 per doek\".",
		"pieceNounPlaceholder": "Bijvoorbeeld doek of navulling"
	},
	"error": {
		"slugTaken": "Een ander product heeft deze slug al.",
		"slug": "Gebruik kleine letters, cijfers en losse streepjes ertussen.",
		"skuTaken": "Een andere variant heeft (of had) deze SKU.",
		"eanTaken": "Een andere variant heeft (of had) deze EAN.",
		"eanLength": "Een EAN heeft 13 cijfers.",
		"eanCheckDigit": "Het controlecijfer klopt niet. Kijk de EAN na.",
		"skuSpaces": "Een SKU heeft geen spaties.",
		"weight": "Vul een gewicht in hele grammen in.",
		"optionNameTaken": "Dit product heeft al een optie met deze naam.",
		"valueNameTaken": "Deze optie heeft al een waarde met deze naam.",
		"tooManyVariants": "Dat worden meer dan 100 varianten. Haal eerst waarden weg.",
		"lastVariant": "Een product houdt minstens één variant. Zet hem uit als hij niet te koop is.",
		"combinationTaken": "Een andere variant staat nu voor deze combinatie.",
		"changed": "Iemand anders paste het product net aan. Je ziet nu de nieuwste versie; probeer het opnieuw.",
		"notFound": "Dit product bestaat niet (meer).",
		"bundleWithoutOptions": "Een bundel heeft geen opties: hij bestaat uit onderdelen.",
		"seoTooLong": "Dat is te lang. Houd het kort: Google toont maar een deel.",
		"lowStockThreshold": "Vul een heel aantal stuks in, 0 of meer.",
		"piecesPerPack": "Vul een heel aantal in, van 1 tot 100.000. Leeg laten mag.",
		"pieceNoun": "Houd het kort: hooguit 30 tekens.",
		"altText": "Houd het kort: hooguit 250 tekens.",
		"unknownCategory": "Een van de categorieën bestaat niet meer. Je ziet nu de nieuwste lijst; probeer het opnieuw.",
		"unknownAttributeValue": "Een van de waarden bestaat niet meer. Je ziet nu de nieuwste lijst; probeer het opnieuw.",
		"unknownHolder": "Een van de houders bestaat niet meer. Je ziet nu de nieuwste lijst; probeer het opnieuw.",
		"unknownProductLine": "Deze lijn bestaat niet meer. Je ziet nu de nieuwste lijst; probeer het opnieuw.",
		"twoSizes": "Een product of variant heeft één maat. Zet de andere maat eerst uit.",
		"archived": "Dit product is gearchiveerd. Zet het product eerst terug om het te wijzigen."
	},
	"editor": {
		"basics": "Basis",
		"saving": "Opslaan…",
		"inactiveBadge": "Inactief",
		"hasVariants": "Dit product heeft varianten",
		"hasVariantsDescription": "Bijvoorbeeld formaten of kleuren. Elke combinatie wordt een variant met een eigen SKU.",
		"hasVariantsLocked": "Haal eerst alle opties weg om dit uit te zetten."
	},
	"options": {
		"title": "Opties",
		"name": "Naam van de optie",
		"namePlaceholder": "Bijvoorbeeld Formaat",
		"add": "Optie toevoegen",
		"values": "Waarden van {{option}}",
		"valuePlaceholder": "Typ een waarde, Enter of komma",
		"valueHint": "Typ een waarde en druk op Enter of komma. Sleep een waarde (of gebruik Alt + pijltje) om de volgorde te wijzigen.",
		"removeValue": "{{value}} weghalen",
		"renameValue": "{{value}} hernoemen",
		"moveUp": "{{option}} omhoog",
		"moveDown": "{{option}} omlaag",
		"remove": "Optie {{option}} weghalen",
		"cancel": "Annuleren",
		"removed": "Optie {{option}} weggehaald",
		"valueRemoved": "{{value}} gearchiveerd",
		"variantsOff_one": "{{count}} variant staat nu uit.",
		"variantsOff_other": "{{count}} varianten staan nu uit.",
		"assignQuestion": "Welke waarde krijgen de bestaande varianten?",
		"assignDescription_one": "De variant die er al was, houdt SKU, EAN en prijs en krijgt deze waarde.",
		"assignDescription_other": "De {{count}} varianten die er al waren, houden SKU, EAN en prijs en krijgen deze waarde.",
		"assignDone": "Klopt"
	},
	"variants": {
		"title": "Varianten",
		"samePrice": "Zelfde prijs voor alle varianten",
		"samePriceDescription": "Eén prijs voor alles. Zet uit om per variant een prijs te geven.",
		"sharedPrice": "Prijs incl. btw, voor alle varianten",
		"column": {
			"name": "Variant",
			"price": "Prijs incl. btw",
			"sku": "SKU",
			"ean": "EAN",
			"active": "Actief",
			"actions": "Acties",
			"piecesPerPack": "Per verpakking"
		},
		"priceOf": "Prijs van {{variant}}",
		"skuOf": "SKU van {{variant}}",
		"eanOf": "EAN van {{variant}}",
		"activeOf": "{{variant}} actief",
		"details": "Details van {{variant}}",
		"delete": "{{variant}} verwijderen",
		"deleted": "{{variant}} verwijderd",
		"archived": "Gearchiveerde waarde",
		"archivedDescription": "Deze variant heeft een weggehaalde waarde en blijft uit tot je die terugzet.",
		"empty": "Voeg een waarde toe aan een optie; de varianten verschijnen hier meteen.",
		"piecesPerPackOf": "Aantal per verpakking van {{variant}}",
		"piecesFromComponents": "Som"
	},
	"photos": {
		"title": "Foto's",
		"description": "De eerste foto is de hoofdfoto. Sleep een foto (of gebruik Alt + pijltje) om de volgorde te wijzigen.",
		"list": "Foto's van het product",
		"photo": "Foto {{position}} van {{count}}",
		"main": "Hoofdfoto",
		"moveLeft": "{{photo}} naar voren",
		"moveRight": "{{photo}} naar achteren",
		"moved": "Foto staat nu op plaats {{position}} van {{count}}.",
		"movedFirst": "Foto is nu de hoofdfoto.",
		"delete": "{{photo}} verwijderen",
		"deleteTitle": "Foto verwijderen?",
		"deleteDescription": "De foto verdwijnt uit beheer en shop, en het bestand wordt gewist. Dat kun je niet ongedaan maken.",
		"deleteConfirm": "Verwijderen",
		"drop": "Sleep foto's hierheen of kies bestanden",
		"dropHint": "JPEG, PNG, WebP of AVIF, tot 10 MB per foto. Packshots op wit werken het best.",
		"uploads": "Foto's die worden geüpload",
		"uploading": "{{name}} uploaden",
		"notAnImage": "{{name}} is geen JPEG, PNG, WebP of AVIF.",
		"tooLarge": "{{name}} is groter dan 10 MB.",
		"offline": "{{name}} kwam niet aan. Kijk je verbinding na en probeer het opnieuw.",
		"failed": "{{name}} uploaden lukte niet. Probeer het opnieuw.",
		"altTextOf": "Alt-tekst van {{photo}}",
		"altTextPlaceholder": "Alt-tekst: wat staat erop?"
	},
	"panel": {
		"description": "Wat niet in de tabel past.",
		"stock": "Voorraad",
		"delete": "Variant verwijderen",
		"deleteDescription": "De variant verdwijnt uit beheer en shop. Oude orders en facturen houden hem, en SKU en EAN blijven bezet."
	},
	"catalogLinks": {
		"label": "Indeling van het assortiment"
	},
	"catalog": {
		"title": "Indeling in de shop",
		"description": "De categorieën en kenmerken waarop klanten het product vinden en filteren, en de lijn waarin het een pak is.",
		"categories": "Categorieën",
		"categoriesDescription": "Het product staat op de pagina van elke categorie die aan staat.",
		"noCategories": "Er zijn nog geen categorieën.",
		"manageCategories": "Categorieën beheren",
		"attributes": "Kenmerken",
		"attributesDescription": "Een waarde hier geldt voor alle varianten. Verschilt het per variant, zet de waarde dan bij de variant.",
		"noAttributes": "Er zijn nog geen kenmerken met waarden.",
		"manageAttributes": "Kenmerken beheren",
		"line": "Lijn",
		"lineDescription": "De pakken van dezelfde navulling in een ander aantal. De shop zet de pakken van een lijn naast elkaar, met wat je bespaart. Een product zit in hooguit één lijn.",
		"noLine": "Geen lijn",
		"noLines": "Er zijn nog geen lijnen.",
		"manageLines": "Lijnen beheren",
		"fit": "Pasvorm",
		"fitDescription": "Past de variant op deze houder, of niet? Wat je op onbekend laat, noemt de shop niet.",
		"noHolders": "Er zijn nog geen houders.",
		"manageHolders": "Houders beheren",
		"fitUnknown": "Onbekend",
		"fitFits": "Past op",
		"fitNotFor": "Niet voor",
		"variantAttributes": "Kenmerken van deze variant",
		"variantAttributesDescription": "Vervangt voor dit kenmerk de waarde van het product.",
		"sizeHint": "maat, kies er één"
	},
	"delete": {
		"button": "Verwijderen",
		"title": "{{name}} verwijderen?",
		"titleArchive": "{{name}} archiveren?",
		"checking": "Even kijken wat er met dit product gebeurt…",
		"planFailed": "Het lukte niet om na te gaan wat er met dit product gebeurt. Sluit dit venster en probeer het opnieuw.",
		"willDelete": "Dit product staat niet in orders of kortingscodes, heeft geen voorraadmutaties na de beginvoorraad en zit niet in een bundel, dus het wordt echt verwijderd: met zijn varianten, foto's, prijzen en beginvoorraad. Dat kun je niet ongedaan maken.",
		"willArchive": "Dit product {{reasons}}, dus het wordt gearchiveerd: het verdwijnt uit de shop en uit de productlijst, en is niet meer te koop.",
		"reasonJoin": ", en ",
		"reason": {
			"orders_one": "staat in {{count}} order",
			"orders_other": "staat in {{count}} orders",
			"stockMovements_one": "heeft {{count}} voorraadmutatie na de beginvoorraad",
			"stockMovements_other": "heeft {{count}} voorraadmutaties na de beginvoorraad",
			"bundles_one": "zit in de bundel {{names}}",
			"bundles_other": "zit in {{count}} bundels ({{names}})",
			"discountCodes_one": "staat in kortingscode {{codes}}",
			"discountCodes_other": "staat in {{count}} kortingscodes ({{codes}})"
		},
		"bundlesStop": "Een bundel met een gearchiveerd onderdeel is ook niet meer te koop.",
		"archiveKeeps": "Orders, facturen en omzet blijven zoals ze zijn. Je kunt het later terugzetten via het filter Gearchiveerd.",
		"confirm": "Definitief verwijderen",
		"confirmArchive": "Archiveren",
		"deleted": "{{name}} is verwijderd",
		"archived": "{{name}} is gearchiveerd",
		"failed": "Het verwijderen lukte niet. Probeer het opnieuw."
	},
	"archived": {
		"title": "Gearchiveerd op {{date}}",
		"description": "Dit product staat niet in de shop en niet in de productlijst, en is niet te koop. Orders en facturen houden het. Zet je het terug, dan staat het weer zoals het was.",
		"readOnly": "Zolang het gearchiveerd is, kun je niets aan dit product wijzigen. Zet het product eerst terug.",
		"readOnlyHint": "Zet het product eerst terug",
		"restore": "Terugzetten",
		"restoreNamed": "{{name}} terugzetten",
		"restored": "{{name}} is teruggezet",
		"restoreFailed": "Het terugzetten lukte niet. Probeer het opnieuw."
	},
	"help": {
		"list": {
			"title": "Productlijst",
			"area": "Producten",
			"short": "De producten op naam, met hun prijs en status; gearchiveerde zie je alleen met het filter. Zoek op naam of SKU. Categorieën, kenmerken, houders en lijnen hebben elk een eigen scherm: de knoppen bovenaan.",
			"terms": [
				"product:status",
				"product:new",
				"category:categories",
				"attribute:attributes",
				"holder:holders",
				"productLine:lines"
			]
		},
		"status": {
			"title": "Status",
			"area": "Producten",
			"short": "Elk product is actief, inactief of gearchiveerd. Zonder filter zie je actief en inactief samen. Een gearchiveerd product zie je alleen met het filter Gearchiveerd.",
			"choices": [
				{
					"name": "Actief",
					"text": "In de shop en te koop."
				},
				{
					"name": "Inactief",
					"text": "Uit de shop, maar nog in het beheer en in oude orders. Je zet het aan in de productbewerker."
				},
				{
					"name": "Gearchiveerd",
					"text": "Verwijderd terwijl het geschiedenis had. Alleen nog te lezen; met Terugzetten staat het er weer."
				}
			],
			"terms": ["product:active", "product:delete"]
		},
		"new": {
			"title": "Nieuw product",
			"area": "Producten › Nieuw product",
			"short": "Je slaat eerst de soort, de naam, de prijs en het btw-tarief op. Daarna opent het product met één variant. Daar voeg je opties, foto's en de indeling toe, bij een bundel de onderdelen.",
			"warning": "De soort kies je alleen hier: een gewoon product wordt later geen bundel, en een bundel geen gewoon product.",
			"terms": [
				"product:kind",
				"price:consumerPrice",
				"product:vatRate",
				"product:options",
				"product:photos",
				"product:catalog",
				"bundle:components"
			]
		},
		"editor": {
			"title": "Product bewerken",
			"area": "Producten",
			"short": "Alles van één product op één pagina, van boven naar beneden. Elk veld slaat zichzelf op zodra je het verlaat, en de shop toont het meteen.",
			"terms": ["product:basics", "product:variants", "price:pricing", "product:delete"]
		},
		"basics": {
			"title": "Basis",
			"area": "Producten › Basis",
			"short": "De naam, de omschrijving, het btw-tarief en of het product te koop is. Heeft het product geen varianten, dan staan de prijs, SKU, EAN en het gewicht hier ook.",
			"terms": [
				"product:kind",
				"product:vatRate",
				"product:active",
				"price:consumerPrice",
				"product:sku",
				"product:slug"
			]
		},
		"kind": {
			"title": "Soort product",
			"area": "Producten › Basis",
			"short": "Een product is standaard of een bundel. Je kiest de soort bij een nieuw product; daarna verandert hij niet meer.",
			"choices": [
				{
					"name": "Standaard",
					"text": "Eén product, eventueel met varianten zoals formaten."
				},
				{
					"name": "Bundel",
					"text": "Een set van varianten van andere producten, zoals een startpakket."
				}
			],
			"terms": ["bundle:components"]
		},
		"vatRate": {
			"title": "Btw-tarief",
			"area": "Producten › Basis",
			"short": "Het btw-tarief van het product: 21% voor bijna alles. Wijzig je het, dan blijft de prijs incl. btw gelijk en verandert de prijs excl. btw die zakelijke klanten zien.",
			"terms": ["price:consumerPrice", "price:customerGroup"]
		},
		"slug": {
			"title": "Slug",
			"area": "Producten › Basis",
			"short": "Het laatste stuk van het adres van het product in de shop: cleanbudget.nl/product/floorwipes-xxl. Kleine letters, cijfers en streepjes.",
			"warning": "Wijzig je de slug, dan werkt het oude adres niet meer: een link in een mail of bij Google geeft dan een foutpagina."
		},
		"active": {
			"title": "Actief",
			"area": "Producten › Basis",
			"short": "Aan: het product staat in de shop en is te koop. Uit: het verdwijnt uit de shop, maar blijft in het beheer en in oude orders.",
			"terms": ["product:delete"]
		},
		"sku": {
			"title": "SKU en EAN",
			"area": "Producten › Varianten",
			"short": "De SKU is je eigen code voor een variant, zonder spaties. De EAN is de barcode van 13 cijfers; die mag leeg blijven. Elke variant heeft zijn eigen.",
			"warning": "Een SKU of EAN blijft bezet, ook als de variant verwijderd is. Een andere variant kan hem niet meer krijgen.",
			"terms": ["product:variants"]
		},
		"photos": {
			"title": "Foto's",
			"area": "Producten › Foto's",
			"short": "De eerste foto is de hoofdfoto: die staat op de producttegel en vooraan op de productpagina. De andere volgen op de productpagina, in deze volgorde.",
			"warning": "Zonder foto zet de shop een tekening op de plek van de foto. De alt-tekst leest een schermlezer voor in plaats van de foto."
		},
		"catalog": {
			"title": "Indeling in de shop",
			"area": "Producten › Indeling",
			"short": "Waar klanten het product vinden: in welke categorieën, met welke kenmerken om op te filteren, in welke lijn, en op welke houders het past.",
			"terms": ["product:category", "product:attribute", "productLine:lines", "product:fit"]
		},
		"category": {
			"title": "Categorie",
			"area": "Producten › Indeling",
			"short": "Een deel van het assortiment in de shop, zoals wegwerp, wasbaar of navulling. Een product kan in meer categorieën staan, en staat dan op de pagina van elk.",
			"goTo": {
				"to": "/product/category",
				"label": "Naar Categorieën"
			}
		},
		"attribute": {
			"title": "Kenmerk",
			"area": "Producten › Indeling",
			"short": "Een eigenschap waarop klanten filteren, met vaste waarden, zoals formaat of soort. Een waarde bij het product geldt voor alle varianten; een waarde bij een variant gaat voor.",
			"warning": "Een kenmerk is geen optie: met een optie kiest de klant een variant, met een kenmerk filtert hij.",
			"terms": ["product:options"],
			"goTo": {
				"to": "/product/attribute",
				"label": "Naar Kenmerken"
			}
		},
		"holder": {
			"title": "Houder",
			"area": "Producten › Indeling",
			"short": "Het apparaat dat de klant al heeft en waar een navulling op gaat: een vloerwisser, standaard of XXL, of een duster. De shop verkoopt ook houders.",
			"terms": ["product:fit"],
			"goTo": {
				"to": "/product/holder",
				"label": "Naar Houders"
			}
		},
		"fit": {
			"title": "Pasvorm",
			"area": "Producten › Indeling",
			"short": "Per houder: past de variant erop, of juist niet? De shop zegt het allebei, in het maatlabel. Wat je op onbekend laat, noemt de shop niet.",
			"choices": [
				{
					"name": "Onbekend",
					"text": "Nog niet zeker. De shop zegt er niets over."
				},
				{
					"name": "Past op",
					"text": "Zeker weten dat het past. Groen, met een vinkje."
				},
				{
					"name": "Niet voor",
					"text": "Zeker weten dat het niet past. Rood, met een kruisje."
				}
			],
			"warning": "Onbekend is nooit \"past op\". Zet alleen Past op als je het zeker weet: een klant die het verkeerde koopt, stuurt het terug.",
			"terms": ["product:holder", "product:sizeLabel"]
		},
		"sizeLabel": {
			"title": "Maatlabel",
			"area": "Producten › Indeling",
			"short": "De maat met de pasvorm, bij elk product in de shop: \"46×27 cm · past op XXL-wissers\". Ook als het antwoord nee is. De maat is de waarde van het kenmerk dat een maat is.",
			"terms": ["product:fit", "product:attribute"]
		},
		"pack": {
			"title": "Pak",
			"area": "Producten › Indeling",
			"short": "Eén variant met een aantal per verpakking, naast de andere pakken van zijn lijn. Het kleinste pak heeft de minste stuks. \"Bespaar X%\" vergelijkt de prijs per doek met die van het kleinste pak.",
			"terms": ["productLine:lines", "product:piecesPerPack", "product:pricePerPiece"]
		},
		"piecesPerPack": {
			"title": "Aantal per verpakking",
			"area": "Producten › Varianten",
			"short": "Hoeveel doekjes of navullingen er in één verpakking zitten. De shop deelt de prijs erdoor: dat is de prijs per doek. Leeg voor iets zonder losse stuks, zoals een wisser.",
			"warning": "Bij een bundel telt de shop de stuks van de onderdelen op. Vul het alleen in als dat niet klopt.",
			"terms": ["product:pricePerPiece", "product:pack"]
		},
		"pricePerPiece": {
			"title": "Prijs per doek",
			"area": "Producten › Varianten",
			"short": "De prijs van een pak gedeeld door het aantal per verpakking: \"€0,45 per doek\". De shop zet hem groot op de tegel en de productpagina, zodat een klant de pakken vergelijkt.",
			"warning": "Heet één stuk anders, zoals navulling, vul dat dan in bij Naam van één stuk in het zijpaneel van de variant.",
			"terms": ["product:piecesPerPack"]
		},
		"options": {
			"title": "Opties en varianten",
			"area": "Producten › Varianten",
			"short": "Een optie is waarin het product verschilt, zoals Formaat, met waarden als Standaard en XXL. Elke combinatie van waarden wordt meteen een variant, met een eigen SKU.",
			"warning": "Haal je een waarde weg, dan gaan de varianten met die waarde uit. Haal je een optie weg, dan blijft van varianten die alleen daarin verschilden er één over. Direct daarna kun je het ongedaan maken.",
			"terms": ["product:variants", "product:attribute"]
		},
		"variants": {
			"title": "Varianten",
			"area": "Producten › Varianten",
			"short": "Een variant is één combinatie van waarden, met een eigen SKU, EAN, prijs en voorraad. Klik op de naam voor het zijpaneel met de rest.",
			"choices": [
				{
					"name": "Zelfde prijs voor alle varianten",
					"text": "Aan: één prijs voor alles. Uit: elke variant zijn eigen prijs."
				}
			],
			"terms": ["product:options", "product:sku", "product:variantActive", "product:variantPanel"]
		},
		"variantActive": {
			"title": "Variant aan of uit",
			"area": "Producten › Varianten",
			"short": "Uit: de variant is niet te koop. Hij blijft in het beheer, met zijn SKU, voorraad en oude orders. Zet je hem aan, dan is hij weer te koop.",
			"terms": ["product:deleteVariant"]
		},
		"variantPanel": {
			"title": "Zijpaneel van een variant",
			"area": "Producten › Varianten",
			"short": "Alles van één variant: prijs, SKU, EAN, gewicht, aantal per verpakking, kenmerken, pasvorm, voorraad en een eigen staffel. Wat je hier invult, geldt alleen voor deze variant.",
			"terms": [
				"product:piecesPerPack",
				"product:fit",
				"product:variantStock",
				"price:variantQuantityDiscount",
				"product:deleteVariant"
			]
		},
		"variantStock": {
			"title": "Voorraad van een variant",
			"area": "Producten › Varianten",
			"short": "Hoeveel stuks er per locatie liggen. Beschikbaar is de voorraad min wat gereserveerd is voor orders die nog niet betaald zijn. Ontvangen of corrigeren doe je onder Voorraad.",
			"goTo": {
				"to": "/stock",
				"label": "Naar Voorraad"
			}
		},
		"deleteVariant": {
			"title": "Variant verwijderen",
			"area": "Producten › Varianten",
			"short": "De variant verdwijnt uit het beheer en de shop. Oude orders en facturen houden hem. Direct daarna kun je het ongedaan maken.",
			"warning": "Zijn SKU en EAN blijven bezet. Wil je de variant later misschien terug, zet hem dan liever uit.",
			"terms": ["product:variantActive", "product:sku"]
		},
		"delete": {
			"title": "Verwijderen en archiveren",
			"area": "Producten",
			"short": "Verwijderen wist een product zonder geschiedenis. Staat het in een order, een bundel of een kortingscode, of heeft het een reservering of voorraadmutaties na de beginvoorraad, dan wordt het gearchiveerd. Voordat er iets gebeurt, zie je welke.",
			"choices": [
				{
					"name": "Verwijderd",
					"text": "Weg, met varianten, foto's en prijzen. Dat kun je niet ongedaan maken."
				},
				{
					"name": "Gearchiveerd",
					"text": "Weg uit de shop en de productlijst; orders en facturen houden het. Alleen nog te lezen."
				},
				{
					"name": "Terugzetten",
					"text": "Zet een gearchiveerd product terug zoals het was. Je vindt het met het filter Gearchiveerd."
				}
			],
			"warning": "Een bundel met een gearchiveerd onderdeel is ook niet meer te koop.",
			"terms": ["product:active"]
		}
	},
	"helpExample": {
		"product": "Floorwipes XXL",
		"tile": "Voorbeeld uit de shop: de producttegels van Floorwipes XXL, met een tekening op de plek van de hoofdfoto. Pak van 20, €0,45 per doek, €8,95, Kleinste pak. Pak van 100, €0,30 per doek, €29,95, Bespaar 33%. Beide met past op XXL-wissers en In mand.",
		"packs": "Voorbeeld uit de shop: de pakken van de lijn Floorwipes XXL. 20 stuks €8,95, €0,45 per doek, Kleinste pak. 60 stuks €19,95, €0,33 per doek, Bespaar 27%. 100 stuks €29,95, €0,30 per doek, Bespaar 33%.",
		"sizeLabels": "Voorbeeld uit de shop: twee maatlabels. Past op XXL-wissers, 46×27 cm. Niet voor XXL-wissers, 28×22 cm.",
		"pricePerPiece": "Voorbeeld uit de shop: €0,45 per doek groot, €8,95 voor het pak van 20.",
		"fit": {
			"sandbox": "Kies per houder de pasvorm, en kijk wat de klant ziet.",
			"holderXxl": "XXL-wissers",
			"holderStandard": "standaard wissers",
			"size": "46×27 cm",
			"label": "Voorbeeld uit de shop: het maatlabel. {{label}}",
			"nothing": "Alleen de maat: 46×27 cm."
		},
		"piecesPerPack": {
			"sandbox": "Kies het aantal per verpakking en de prijs van het grote pak, en kijk wat de klant ziet.",
			"pieces": "Aantal per verpakking",
			"price": "Prijs incl. btw",
			"fewer": "Minder per verpakking",
			"more": "Meer per verpakking",
			"cheaper": "Een euro goedkoper",
			"dearer": "Een euro duurder",
			"label": "Voorbeeld uit de shop: de pakken van Floorwipes XXL. 20 stuks €8,95, €0,45 per doek, Kleinste pak. {{pieces}} stuks {{price}}, {{perPiece}} per doek{{saving}}.",
			"saving": ", Bespaar {{percent}}%"
		},
		"options": {
			"steps": {
				"add": "Zet Dit product heeft varianten aan",
				"name": "Typ de naam van de optie: Formaat",
				"first": "Typ een waarde en druk op Enter: Standaard",
				"second": "Typ nog een waarde: XXL",
				"variants": "Elke waarde is meteen een variant, met een eigen SKU"
			},
			"animation": "Animatie: je zet Dit product heeft varianten aan, typt de optie Formaat met de waarden Standaard en XXL, en er komen meteen twee varianten bij.",
			"option": "Formaat",
			"standard": "Standaard",
			"xxl": "XXL",
			"product": "Vloerwisser"
		},
		"new": {
			"steps": {
				"kind": "Kies de soort: Gewoon product",
				"name": "Typ de naam en de prijs",
				"save": "Klik op Product aanmaken",
				"editor": "Het product opent, met één variant",
				"next": "Daarna voeg je opties, foto's, de indeling en de prijzen toe"
			},
			"animation": "Animatie: je kiest de soort Gewoon product, typt de naam Floorwipes XXL en de prijs 8,95, en klikt op Product aanmaken. Het product opent met één variant. Daaronder voeg je opties, foto's, de indeling en de prijzen toe.",
			"price": "8,95",
			"variant": "Eén variant"
		}
	}
}
